import { render, staticRenderFns } from "./Why-Us.vue?vue&type=template&id=afe8d000"
import script from "./Why-Us.vue?vue&type=script&lang=js"
export * from "./Why-Us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports